<div class="loading-container" #loadingContainer>
  <img src="assets/images/logo.png" class="loading-image" alt="Loading...">
</div>
